<template>
  <div
    class="module-item"
    :class="{ on: showMore, 'wait-unlock': !data.is_unlock }"
  >
    <div
      class="head-box"
      :style="{ 'padding-top': moduleType === 0 ? '22px' : '16px' }"
      @click="showMore = !showMore"
    >
      <div class="name" style="-webkit-box-orient: vertical;">{{ data.name }}</div>
      <div class="unlock-time" v-if="data.unlock_time">
        {{ data.unlock_time | dateStr }}
      </div>
    </div>
    <div class="body-box" v-show="showMore" v-cloak>
      <template v-for="(item, index) in data.details">
        <div
          class="detail"
          :key="index"
          :class="`detail-${item.object_type}`"
          @click.stop="onClick(item)"
        >
          <span class="text" style="-webkit-box-orient: vertical;">{{ item.name }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { MODULE_DETAILS_OBJ_TYPE, LESSON_TYPE } from '@/common/js/config';
import { getStudyFinished, getUserViewData } from '@/api/api';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    paid: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: Number,
      default: 0,
    },
    seriesId: {
      type: Number,
      default: 0,
    },
    campOpened: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    dateStr(time) {
      let res = time.replace(/-/g, '.');
      res = res.substr(0, 10);
      return res;
    },
  },
  data() {
    return {
      showMore: false,
    };
  },
  mounted() {
    // 预习模块
    if (this.moduleType === 0) {
      this.showMore = true;
    }
  },
  methods: {
    async onClick(data) {
      const res = await getUserViewData(this.seriesId);
      if (!res.data.is_paid) {
        Toast('立即购买，开启学习之旅吧～');
        return;
      }

      if (!this.data.is_unlock) {
        Toast('未解锁哦~');
        return;
      }

      if (data.object_type === MODULE_DETAILS_OBJ_TYPE.lesson) {
        if (
          data.lesson_type === LESSON_TYPE.video
          || data.lesson_type === LESSON_TYPE.voice
        ) {
          // 视频 || 音频
          this.$router.push({
            name: 'camp-play',
            params: {
              lesson_id: data.object_id,
            },
            query: {
              cid: this.data.id,
              lt: data.lesson_type,
              sid: this.seriesId,
              t: +new Date(),
            },
          });
        } else if (data.lesson_type === LESSON_TYPE.extUrl) {
          // 外链
          if (data.require_study) {
            getStudyFinished(data.id).then(() => {
              window.location.href = data.metas.ext_url;
            });
          } else {
            window.location.href = data.metas.ext_url;
          }
        }
      } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.clock) {
        // console.log(this.$router);
        this.$router.push({
          path: '/clock-in-theme',
          query: {
            id: data.id, // detail_id
          },
        });
      }
      // if (this.paid) {
      //   Toast('点击下方按钮开始学习哦～');
      // } else {
      //   Toast('立即购买，开启学习之旅吧～');
      // }
      // if (value.object_type === MODULE_DETAILS_OBJ_TYPE.lesson) {
      //   console.log('去课程播放页面');
      // } else if (value.object_type === MODULE_DETAILS_OBJ_TYPE.clock) {
      //   console.log('去打卡');
      // }
      // //  else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.exam) {
      // //   console.log('考试')
      // // } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.live) {
      // //   console.log('去直播页')
      // // } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.material) {
      // //   console.log('下载资料')
      // //   Toast('App功能更齐全哦~')
      // // } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.content) {
      // //   console.log('去图文页面')
      // // }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';

.module-item {
  position: relative;
  width: 100%;
  background: #F6F7FA;
  border-radius: 4px;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 22px;
    right: 16px;
    width: 12px;
    height: 12px;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAHlBMVEUAAACqqqqZmZmZmZmZmZmZmZmZmZmZmZmYmJiZmZlv08dvAAAACXRSTlMAAw8ewMjS2t1lK8PQAAAASUlEQVQY02NgGBDAmKIAopjcBECcyiAQR3U6iMNgMRUoxRTZDFbH3AmUUp1hANEFlIJJgKXgEiApuARICiHBwGBejGyxAHU8AAAxXA1agMm2HAAAAABJRU5ErkJggg==') center no-repeat;
    background-size: cover;
  }

  &.on {
    &::after {
      background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAHlBMVEUAAACqqqqZmZmZmZmZmZmZmZmZmZmZmZmYmJiZmZlv08dvAAAACXRSTlMAAw8ewMjS2t1lK8PQAAAASElEQVQY02NgoApgFEDimBcj2MydMwzgHIupkc0IiSBVuJTFVAUmmBRQgoEBJgWUYGCASjFWBoEo1ekguxhTFEAcJjcBhgEBABJTDVrfILerAAAAAElFTkSuQmCC') center no-repeat;
      background-size: cover;
    }
  }

  &.wait-unlock {
    .head-box {
      .name {
        color: #999999;
      }
    }

    .body-box {
      .detail {
        padding-right: 52px;
        color: #999;

        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 14px;
          right: 12px;
          width: 24px;
          height: 24px;
          background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAV1BMVEUAAAD////U1NTq6urb29vc3Nze3t7Z2dnd3d3a2trb29va2trb29va2trb29va2tra2tra2tra2tra2tra2tre3t7k5OTn5+fw8PDx8fH6+vr9/f3///9BNV4PAAAAFHRSTlMAAQYMDiQvPUN9iJmarL/X6u3u8nBsIlcAAADCSURBVEjH7ZTJDoMgFEUdcMABFC9S8f3/d3bRNnWhhZcmrQvPipu8wwxJcvEr6lZPk27ryPJC4YkqYuqrEYMs87yUA8Yqov8RvXg0RY8xPIZCn77aaQ8VXC8G8U5iQGjlHeQ2SnQBQaPcxhI6IEzItzHHFBCAz/krIWsMdjFNtis0OKTZFcyxYA6mf8wJhNn7mSV4Is8SVqKVJSxEC0twRI4lWCLL21bvmedwW5iCc0zB2rPdpSiB/YDYT5T9CVz8kTs4BjS8S/VXPwAAAABJRU5ErkJggg==') center no-repeat;
          background-size: cover;
        }

        .text {
          color: #999;
        }
      }
    }
  }
}

.head-box {
  width: 100%;
  padding: 16px 40px 16px 16px;

  .name {
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    color: $color-text;
    line-height: 24px;
    multi-line(2);
  }

  .unlock-time {
    margin-top: 6px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 12px;
  }
}

.body-box {
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: calc(100% - 32px);
    height: 0.5px;
    margin: auto;
    background: #E7E7E7;
  }

  .detail {
    position: relative;
    width: 100%;
    padding: 16px 16px 16px 67px;

    .text {
      display: inline-block;
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      multi-line(2);
    }

    &::before {
      content: '';
      position: absolute;
      left: 16px;
      top: 16px;
      font-size: 14px;
      font-weight: 400;
      color: #999;
      line-height: 20px;
    }

    &.detail-93 {
      &::before {
        content: '直播 |';
      }
    }

    &.detail-131 {
      &::before {
        content: '打卡 |';
      }
    }

    &.detail-132 {
      &::before {
        content: '考试 |';
      }
    }

    &.detail-133 {
      &::before {
        content: '资料 |';
      }
    }

    &.detail-134 {
      &::before {
        content: '图文 |';
      }
    }

    &.detail-135 {
      &::before {
        content: '课程 |';
      }
    }
  }
}
</style>
